import React from 'react';

export const Container = ({ className = '', children, ...props }) => (
  <div className={`mx-auto w-full max-w-[1240px] px-5 sm:px-8 ${className}`} {...props}>{children}</div>
);

export const Section = ({ id, className = '', children, ...props }) => (
  <section id={id} className={`py-16 sm:py-24 ${className}`} {...props}>
    <Container>{children}</Container>
  </section>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs font-semibold uppercase tracking-[0.14em] text-accent">{children}</p>
);

export const SectionHeading = ({ eyebrow, title, desc, align = 'left', as: Tag = 'h2' }) => (
  <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Tag className="mt-3 text-[30px] font-bold leading-[1.1] tracking-tight text-primary sm:text-[36px] lg:text-[46px]">{title}</Tag>
    {desc && <p className="mt-4 text-[17px] leading-relaxed text-muted-foreground sm:text-lg">{desc}</p>}
  </div>
);

export const ExampleBadge = ({ children = 'Example' }) => (
  <span className="inline-flex items-center rounded-full border border-border bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">{children}</span>
);
